import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热播榜单</h2>
            <p className="mt-2 text-sm text-foreground-500">实时热度排行，大家都在追</p>
          </div>
          <div className="hidden sm:flex items-center gap-1.5">
            {['日榜', '周榜', '月榜'].map((tab) => (
              <span
                key={tab}
                className={`px-3 py-1.5 rounded-full text-xs font-medium cursor-pointer whitespace-nowrap ${
                  tab === '周榜'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-500 hover:bg-background-200 transition-colors'
                }`}
              >
                {tab}
              </span>
            ))}
          </div>
        </div>

        <div className="bg-background-50 rounded-lg overflow-hidden">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-5 px-4 md:px-6 py-3 md:py-4 border-b border-background-100 last:border-b-0 hover:bg-background-100 transition-colors cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center text-sm font-bold ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {item.title}
                  </h3>
                  <span className="flex-shrink-0 px-1.5 py-0.5 rounded text-[10px] font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.type}
                  </span>
                </div>
                <p className="mt-0.5 text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 flex items-center gap-2">
                <span className="text-sm md:text-base font-semibold text-accent-500 whitespace-nowrap">{item.heat}</span>
                <i className={`text-sm ${
                  item.trend === 'up' ? 'text-primary-500 ri-arrow-up-line' :
                  item.trend === 'new' ? 'text-accent-500 ri-add-line' :
                  'text-foreground-400 ri-subtract-line'
                }`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}